import { notification } from "antd";

import {
  setLoadingType,
  setErrorType,
  setPasswordScreen,
  setModal,
  openHeaderBox,
} from "../../../components/dataflow/utils-module";
import { setClearFilters } from "../../../components/dataflow/filters-module";
import { setTabs } from "../../../components/dataflow/tabs-module";
import API from "../../../services/Api";
import { msalInstance } from "../../../services/msalInstance";
import { clearPersistedAuthTokens } from "../../../services/persistedAuth";
import { persistor } from "../../../store";
import {
  saveBackendToken,
  saveProfileToken,
  saveUserdata,
  clearData,
} from "./auth-module";
import { shouldRedirectToB2B } from "../../b2b/utils/permissions";

export const logoutUser = () => async (dispatch) => {
  dispatch(clearData());
  dispatch(setClearFilters([]));
  dispatch(setTabs([]));
  dispatch(openHeaderBox({ type: "", isOpen: false }));

  try {
    await persistor.flush();
  } catch (e) {
    console.error(e);
  }

  clearPersistedAuthTokens();

  const account =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  const postLogoutRedirectUri = `${window.location.origin}/`;

  if (account) {
    await msalInstance.logoutRedirect({
      account,
      postLogoutRedirectUri,
    });
  } else {
    window.location.assign("/");
  }
};

export const authenticateUser =
  (history, options = {}) =>
  async (dispatch) => {
    try {
      const { clearDataBefore = true } = options;
      dispatch(setErrorType({ type: "" }));
      if (clearDataBefore) dispatch(clearData());

      const { data, status } = await API.post("/profile/me");

      if (status === 200) {
        const needsPhone = !data.attributes.phone;
        const profile = data.attributes.profile;

        if (profile === "Administrador" || profile === "Corporativo") {
          dispatch(setModal({ type: "modal-my-painel" }));
        }

        if (needsPhone) {
          dispatch(setModal({ type: "get-phone-user" }));
        }

        dispatch(
          saveUserdata({
            email: data?.attributes?.email,
            profile: data && data.attributes.profile,
            profilePermissions:
              data && JSON.parse(data.attributes.profilePermissions),
          })
        );
        dispatch(saveProfileToken(data?.AuthenticationResult?.IdToken));

        if (data.attributes) {
          if (data.attributes["custom:campuses"]) {
            dispatch(
              saveUserdata({
                campuses: JSON.parse(data.attributes["custom:campuses"])
                  .campuses,
                email: data?.attributes?.email,
                profile: data && data.attributes.profile,
                profilePermissions:
                  data && JSON.parse(data.attributes.profilePermissions),
              })
            );
          }
        } else if (data.attributes["custom:campuses"]) {
          dispatch(
            saveUserdata({
              campuses: JSON.parse(data.attributes["custom:campuses"]).campuses,
              email: data?.attributes?.email,
              profile: data && data.attributes.profile,
              profilePermissions:
                data && JSON.parse(data.attributes.profilePermissions),
            })
          );
        }

        if (data.attributes) {
          const userdata = {
            email: data?.attributes?.email,
            profile: data.attributes.profile,
            profilePermissions: JSON.parse(data.attributes.profilePermissions),
          };

          if (data.attributes["custom:polos"]) {
            userdata.campuses = JSON.parse(
              data.attributes["custom:polos"]
            ).campuses;
          }

          dispatch(saveUserdata(userdata));
        }
        dispatch(setPasswordScreen("password-reset"));
        setTimeout(() => {
          if (data.attributes.profile === "Call Center Retenção") {
            history.push("/retencao");
          } else if (data.attributes.profile === "Consultor Externo") {
            history.push("/cadastro-de-lead");
          } else if (
            shouldRedirectToB2B({
              profile: data.attributes.profile,
            })
          ) {
            history.push("/b2b");
          } else {
            history.push("/contacts");
          }
        }, 200);
      } else {
        notification.error({
          message: "Erro!",
          description:
            "Ocorreu um erro e não foi possível se autenticar na aplicação!",
        });
      }

      dispatch(setLoadingType({ type: "" }));
    } catch (err) {
      console.log(err);
      dispatch(setLoadingType({ type: "" }));
      notification.error({
        message: "Erro!",
        description:
          "Ocorreu um erro e não foi possível se autenticar na aplicação!",
      });
    }
  };

export const loginWithBackend =
  (email, password, history) => async (dispatch) => {
    try {
      dispatch(setErrorType({ type: "" }));
      dispatch(clearData());
      dispatch(setLoadingType({ type: "login-backend" }));

      const { data, status } = await API.post("/auth/signin", {
        email,
        password,
      });

      if (status !== 200) {
        notification.error({
          message: "Erro!",
          description: "Email ou senha inválidos!",
        });
        dispatch(setLoadingType({ type: "" }));
        return;
      }

      if (data?.AuthenticationResult?.IdToken) {
        dispatch(
          saveBackendToken({
            accessToken: data.AuthenticationResult.IdToken,
            refreshToken: data.AuthenticationResult.RefreshToken,
          })
        );
      }

      setTimeout(() => {
        dispatch(authenticateUser(history, { clearDataBefore: false }));
      }, 1000);
    } catch (err) {
      console.log(err);
      dispatch(setLoadingType({ type: "" }));
      notification.error({
        message: "Erro!",
        description: "Ocorreu um erro e não foi possível realizar o login!",
      });
    }
  };

export const sendResetPasswordMail = (email) => async (dispatch) => {
  try {
    const { status, data } = await API.post("/auth/forgotpassword", {
      email,
    });
    dispatch(setLoadingType({ type: "" }));
    if (status === 200) {
      dispatch(setPasswordScreen("password-recover"));
      notification.success({
        message: "Sucesso!",
        description: "Código enviado com sucesso.",
      });
    } else {
      notification.error({
        message: "Ops!",
        description: `Ocorreu um erro e não foi possível seguir com a solicitação! ${data.message}`,
      });
    }
  } catch (err) {
    notification.error({
      message: "Ops!",
      description: `Ocorreu um erro e não foi possível seguir com a solicitação! ${err.message}`,
    });
    dispatch(setLoadingType({ type: "" }));
  }
};

export const resetPassword =
  (email, password, confirmationCode, confirmPassword, history) =>
  async (dispatch) => {
    try {
      dispatch(setLoadingType({ type: "recover-password" }));
      const { status, data } = await API.post("/auth/changepassword", {
        email,
        password,
        confirmationCode,
        confirmPassword,
      });
      if (status === 200) {
        dispatch(authenticateUser(history));
        notification.success({
          message: "Sucesso!",
          description:
            "Por favor aguarde, estamos realizando o seu login na plataforma.",
        });
      } else {
        notification.error({
          message: "Ops!",
          description: `Ocorreu um erro e não foi possível seguir com a solicitação! ${data.message}`,
        });
      }
    } catch (err) {
      dispatch(setLoadingType({ type: "" }));
      notification.error({
        message: "Ops!",
        description: `Ocorreu um erro e não foi possível seguir com a solicitação! ${err.message}`,
      });
    }
  };
